module.exports = __webpack_public_path__ + "img/chat-rounded.eedcc29c.svg";